import React from "react";
import {KatSpinner} from "@amzn/katal-react";

const LoadingStatusComponent = () => {

    return(
        <>
            <div className="loadingBoxStyle" >
                <KatSpinner size="large"/>
            </div>
        </>
    )
};

export default LoadingStatusComponent;